var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgUserCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m3.987 15.56-.128.314.243.235A8.5 8.5 0 0 0 10 18.5h.002a8.5 8.5 0 0 0 5.897-2.39l.243-.236-.128-.314a6.5 6.5 0 0 0-12.026 0Zm12.491-1.308.431.737.432-.736a8.42 8.42 0 0 0 1.159-4.252V10a8.5 8.5 0 1 0-17 0 8.42 8.42 0 0 0 1.159 4.253l.432.736.43-.737a7.5 7.5 0 0 1 3.666-3.168l.655-.265-.467-.53a3.5 3.5 0 1 1 5.25 0l-.467.53.655.265a7.5 7.5 0 0 1 3.665 3.168ZM4.815 2.052A9.5 9.5 0 0 1 10 .5a9.5 9.5 0 0 1 6.982 15.922 9.5 9.5 0 0 1-13.964 0 9.5 9.5 0 0 1 1.797-14.37Zm3.106 4.56a2.5 2.5 0 1 0 4.158 2.777A2.5 2.5 0 0 0 7.92 6.61Z",
  fill: "currentColor",
  stroke: "currentColor"
})));

export default SvgUserCircle;